import { AIProviderManagement } from "@/components/AIProviderManagement";
import { useNavigate } from "react-router-dom";

export const AIProvidersPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <AIProviderManagement onBack={handleBack} />;
};
